var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0472 11.867V14.162H13.3672V16.967H15.0472V25.3053H18.5005V16.967H20.8172C20.8172 16.967 21.0355 15.622 21.1405 14.1503H18.5139V12.2337C18.5139 11.9453 18.8905 11.5603 19.2639 11.5603H21.1439V8.63867H18.5855C14.9622 8.63867 15.0472 11.447 15.0472 11.867Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2214 30.3057C20.7576 30.3057 24.149 28.9009 26.6494 26.4004C29.1499 23.8999 30.5547 20.5086 30.5547 16.9723C30.5547 13.4361 29.1499 10.0447 26.6494 7.54424C24.149 5.04376 20.7576 3.639 17.2214 3.639C13.6851 3.639 10.2937 5.04376 7.79326 7.54424C5.29278 10.0447 3.88802 13.4361 3.88802 16.9723C3.88802 20.5086 5.29278 23.8999 7.79326 26.4004C10.2937 28.9009 13.6851 30.3057 17.2214 30.3057ZM17.2214 33.639C8.01635 33.639 0.554688 26.1773 0.554688 16.9723C0.554688 7.76733 8.01635 0.305664 17.2214 0.305664C26.4264 0.305664 33.888 7.76733 33.888 16.9723C33.888 26.1773 26.4264 33.639 17.2214 33.639Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cc93c3c298c9df1c88569e8172bebda3.svg";
export { ForwardRef as ReactComponent };